import React, {Component} from 'react';
import PropTypes from "prop-types";

class Thead extends Component {
    static propTypes = {
        titles: PropTypes.array,
    };
    static defaultProps = {
        titles: [],
    };

    render() {
        let {titles} = this.props;

        return (
            <thead style={{
                height:'10%',
            }}>
                <tr style={{
                    background:'#addaeb'
                }}>
                    { titles &&
                        titles.map( (column, index)=> {
                            return (
                                <td key={index} className={`table-header ${column.className}`}
                                    style={{
                                        textAlign:'center',
                                        padding:'5px',
                                        maxWidth:'50%'
                                    }}
                                >
                                    {column.title}
                                </td>);
                        })
                    }
                </tr>
            </thead>
        );
    }
}

export default Thead;